// import * as yup from 'yup'

import objectivesSchema from './objectivesSchema'

const newObjectiveFormSchema = (t) => objectivesSchema(t)

export default newObjectiveFormSchema
